<template>

  <div id="app">

    <div class="col-12 bg-header">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-2 text-center">
            <img src="https://www.rueden.de/images/Logo-Horizontal-inversion.png" alt="VON RUEDEN"/>
          </div>
          <div class="col-12 col-md-8 text-center">
            <h1>Ihr persönlicher Fragebogen</h1>
          </div>
        </div>
      </div>
    </div>

    <div v-if="uploadInProgress" class="upload-progress">

      <div class="spinner-border" role="status">

        <span class="sr-only">Lade ...</span>

      </div>
      <h2>Bitte warten. Dokument wird hochgeladen.</h2>

    </div>

    <div v-if="status_ordner != 'Vollmacht eingegangen' && warteliste != 'Ja'">

      <!-- 1. Stammdaten -->
      <div class="container pt-5 pb-5 mb-5" v-if="schritt === 1">
        <form id="form_1" autocomplete="off">

          <Schrittanzeige :schritt="1"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">
              <div class="formular-box">

                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0 pb-5">1. Kontaktdaten</h2>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="woman" value="Frau" v-model="anrede" name="anrede" data-name="gruppe_stammdaten_1_anrede" @change="update($event);sendGaEvent($event)" required/>
                      <label for="woman" class="">Frau</label>
                    </div>
                    <div class="form-checkboxes form-display-inline">
                      <input id="men" type="radio" value="Herr" v-model="anrede" name="anrede" data-name="gruppe_stammdaten_1_anrede" @change="update($event);sendGaEvent($event)" required/>
                      <label for="men" class="">Herr</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="rueden-input">
                      <label>Vorname</label>
                      <input @focus="sendGaEvent" class="form-control" type="text" v-model="vorname" name="vorname" data-name="gruppe_stammdaten_1_vorname" @change="update($event);sendGaEvent($event)" required/>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="rueden-input">
                      <label>Nachname</label>
                      <input @focus="sendGaEvent" class="form-control" type="text" v-model="nachname" name="nachname" data-name="gruppe_stammdaten_1_nachname" @change="update($event);sendGaEvent($event)" required/>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-7 col-xl-8 pr-0">
                    <p class="form-question">
                      Haben Sie das Fahrzeug für selbstständige Zwecke gekauft?
                      <a v-tooltip="{ content: 'Wenn Sie sich nicht sicher sind, prüfen Sie bitte, ob etwa auf dem Kaufvertrag oder der Bestellung \'Firma\' steht oder ob Sie das Fahrzeug steuerlich geltend gemacht haben. In beiden Fällen geben Sie bitte \'Ja\' an.', trigger: 'click' }">
                        <i class="fa fa-question-circle-o"></i>
                      </a>

                    </p>
                  </div>
                  <div class="col-12 col-md-5 col-xl-4 text-right mobile-md-text-left">
                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="gewerbliche_nutzung_ja" value="Ja" v-model="gewerbliche_nutzung" name="gewerbliche_nutzung" data-name="pkw_gruppe_2_kaeufer_ist_verbraucher" data-value="Nein" @change="update($event);sendGaEvent($event)" required/>
                      <label for="gewerbliche_nutzung_ja">Ja</label>
                    </div>
                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="gewerbliche_nutzung_nein" value="Nein" v-model="gewerbliche_nutzung" name="gewerbliche_nutzung" data-name="pkw_gruppe_2_kaeufer_ist_verbraucher" data-value="Ja" @change="update($event);sendGaEvent($event)" required/>
                      <label for="gewerbliche_nutzung_nein">Nein</label>
                    </div>
                  </div>
                </div>

                <div v-if="gewerbliche_nutzung == 'Ja'" class="row">
                  <div class="col-12">
                    <label>
                      Wer steht als Käufer/in im Kaufvertrag? (inkl. der Rechtsform)
                      <!-- test -->
                      <a v-tooltip="{ content: 'Prüfen Sie dazu bitte das Adressfeld des Kaufvertrags oder der verbindlichen Bestellung.', trigger: 'click' }">
                        <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                      </a>
                    </label>
                  </div>
                  <div class="col-12">
                    <div class="rueden-input">
                      <input @focus="sendGaEvent" class="form-control" type="text" v-model="name_des_kaeufers_im_kaufvertrag" name="name_des_kaeufers_im_kaufvertrag" data-name="name_des_kaeufers_im_kaufvertrag" @change="update($event);sendGaEvent($event)" required/>
                    </div>
                  </div>
                </div>

                <div v-if="gewerbliche_nutzung == 'Nein'" class="row">

                  <div class="col-12 col-md-7 col-xl-8 pr-0">
                    <p class="form-question">Haben Sie das Fahrzeug selbst gekauft?</p>
                  </div>

                  <div class="col-12 col-md-5 col-xl-4 text-right mobile-md-text-left">

                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="gekauft_yes" value="Ja" v-model="kaeufer_auto" name="kaeufer_auto"
                             data-name="kaeufer_auto" @change="update($event);sendGaEvent($event)" required/>
                      <label for="gekauft_yes" class="">Ja</label>
                    </div>

                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="gekauft_no" value="Nein" v-model="kaeufer_auto" name="kaeufer_auto"
                             data-name="kaeufer_auto" @change="update($event);sendGaEvent($event)" required/>
                      <label for="gekauft_no" class="">Nein</label>
                    </div>

                  </div>

                </div>

                <div v-if="kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'" class="row">
                  <div class="col-12 mb-4">
                    <div style="font-size: 16px;" class="alert alert-danger" role="alert">
                      <span class="hinweis-box-icon d-inline" style="color: #fff"><i class="fa fa-exclamation-triangle"
                                                                                     aria-hidden="true"></i></span>
                      Leider kann der Schadensersatz nur von dem/der Käufer/in geltend gemacht werden.
                      <strong>Bitte leiten Sie diesen Link an die zuständige Person weiter!</strong>
                    </div>
                  </div>
                </div>

                <div v-else>

                  <div class="row">

                    <div
                        class="col-12">
                      <div class="rueden-input">
                        <label v-bind:class="{ 'text-danger' : address_empty }">Straße und Hausnummer</label>
                        <!--<small v-bind:class="{ 'text-danger' : address_empty }"> - Wählen Sie bitte eine der Adressen aus.</small>-->
                        <!--<small class="text-danger" v-if="address_missingNo && !address_empty"> - Bitte geben Sie auch
                          eine Hausnummer an.</small>
                        -->
                        <vue-google-autocomplete
                            id="address_google"
                            ref="addressGoogle"
                            classname="form-control"
                            placeholder=""
                            types="address"
                            v-on:placechanged="getAddressData"
                            v-on:blur="blurGetAddressData"
                            :country="['de','ch','at']"
                            v-model="address_google"
                            v-on:focus="sendGAfromAutocomplete"
                        >
                        </vue-google-autocomplete>
                        <input class="form-control d-none" type="text"
                               :class="{'disable' : kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'}"
                               :disabled="kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'" v-model="strasse"
                               name="strasse" data-name="gruppe_stammdaten_1_strasse" @change="update" required/>
                      </div>
                    </div>

<!--                    <div class="col-3">-->
<!--                      <div class="rueden-input">-->
<!--                        <label>Nr.</label>-->
<!--                        <input ref="streetNumber" @focus="sendGaEvent" @change="setStreetNumber();sendGaEvent($event)" class="form-control" type="text" v-model="strasse_nummer" name="strasse_nummer" required/>-->
<!--                      </div>-->
<!--                    </div>-->
                    </div>
                    <div class="row">
                      <div class="col-4 col-md-3">
                        <div class="rueden-input">
                          <label>PLZ</label>
                          <input ref="address_plz" class="form-control" type="text"
                                 :class="{'disable' : kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'}"
                                 :disabled="kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'" v-model="plz"
                                 name="plz" data-name="gruppe_stammdaten_1_plz" @change="update" required/>
                        </div>
                      </div>
                      <div class="col-8 col-md-5">
                        <div class="rueden-input">
                          <label>Ort</label>
                          <input class="form-control" type="text" v-model="ort" name="ort"
                                 data-name="gruppe_stammdaten_1_ort" @change="update" required/>
                        </div>
                      </div>
                      <div class="col-12 col-md-4">
                        <label>Land</label>
                        <div class="control-select">
                          <select v-model="land" name="land" data-name="gruppe_stammdaten_1_land" @change="update"
                                  :class="{'disable' : kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'}"
                                  :disabled="kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'" required>
                            <option v-for="option in land_options" :value="option.value" :key="option.value">
                              {{ option.text }}
                            </option>
                          </select>
                          <div class="select-arrow"></div>
                        </div>
                      </div>
                    </div>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="rueden-input">
                        <label>E-Mail</label>
                        <input @focus="sendGaEvent" class="form-control" type="email"
                               :class="{'disable' : kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'}"
                               :disabled="kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'" v-model="email"
                               name="email" data-name="gruppe_stammdaten_1_e_mail_adresse" @change="update($event);sendGaEvent($event)" required/>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="rueden-input">
                        <label>Telefon</label>
                        <input @focus="sendGaEvent" class="form-control" type="tel"
                               :class="{'disable' : kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'}"
                               :disabled="kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'" v-model="telefon"
                               name="telefon" data-name="gruppe_stammdaten_1_telefonnummer" @change="update($event);sendGaEvent($event)" required/>
                      </div>
                    </div>

                    <div class="col-12 mt-4">
                      <button id="to-step-2" type="submit" @click="sendGaEvent($event);nextStep(1)"
                              :disabled="(kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein') || address_empty"
                              class="btn btn-primary-blue {'disable' : kaeufer_auto == 'Nein' && gewerbliche_nutzung == 'Nein'}">
                        weiter &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>

          <input type="submit" id="hidden_submit_1" value="jetzt"/>

        </form>
      </div>

      <!-- 2. PKW Angaben  -->
      <div class="container pt-5 pb-5" v-if="schritt === 2">
        <form id="form_2" autocomplete="off">

          <Schrittanzeige :schritt="2"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">
              <div class="formular-box">
                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0 pb-5">2. Angaben zum Fahrzeug</h2>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <label>Marke</label>
                    <div class="rueden-input">
                      <vue-simple-suggest @select="updateCarBrand"
                                          :list="carBrands"
                                          :min-length="0"
                                          :max-suggestions="0"
                                          :filter-by-query="true">
                        <input @change="update($event);sendGaEvent($event)"
                               ref="automarke"
                               @focus="sendGaEvent"
                               class="form-control"
                               v-model="automarke"
                               type="text"
                               name="pkw_gruppe_1_automarke"
                               data-name="pkw_gruppe_1_automarke"
                               required
                        />
                      </vue-simple-suggest>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="rueden-input">
                      <label>Modell</label>
                      <input @focus="sendGaEvent" class="form-control" type="text" v-model="modell" data-name="pkw_gruppe_1_modell"
                             @change="update($event);sendGaEvent($event)" required/>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="rueden-input">
                      <label>Kennzeichen</label>
                      <input @focus="sendGaEvent" class="form-control" type="text" v-model="kennzeichen" data-name="pkw_gruppe_1_kennzeichen"
                             @change="update($event);sendGaEvent($event)" required/>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <label>Kraftstoff</label>
                    <div class="control-select">
                      <select v-model="kraftstoff" name="kraftstoff" data-name="pkw_gruppe_1_treibstoff"
                              @change="update($event);sendGaEvent($event)" required>
                        <option v-for="option in kraftstoff_options" v-bind:value="option.value" :key="option.value">
                          {{ option.text }}
                        </option>
                      </select>
                      <div class="select-arrow"></div>
                    </div>
                  </div>
                </div>



                <div class="row">
                  <div class="col-12 mt-4">
                    <button id="to-step-3" @click="sendGaEvent($event);nextStep(2)" type="submit" class="btn btn-primary-blue">weiter &nbsp; <i
                        class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <input type="submit" id="hidden_submit_3" value="jetzt"/>

        </form>
      </div>

      <!-- 3. Versicherung -->
      <div class="container pt-5 pb-5" v-if="schritt === 3">
        <form id="form_3" autocomplete="off">

          <Schrittanzeige :schritt="3"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">
              <div class="formular-box">

                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0 pb-5">3. Angaben zur Rechtsschutzversicherung</h2>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-7 col-lg-7 col-xl-8 pr-0">
                    <p class="form-question">Bestand zum Kaufzeitpunkt eine Rechtsschutzversicherung?</p>
                  </div>
                  <div class="col-12 col-md-5 col-lg-5 col-xl-4 text-right mobile-md-text-left">

                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="rsv_yes" value="Ja" v-model="rsv_bei_kauf_vorhanden"
                             name="rsv_bei_kauf_vorhanden"
                             data-name="gruppe_stammdaten_2_rechtsschutz_bei_kauf_vorhanden" @change="update($event);sendGaEvent($event)" required/>
                      <label for="rsv_yes">Ja</label>
                    </div>

                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="rsv_no" value="Nein" v-model="rsv_bei_kauf_vorhanden"
                             name="rsv_bei_kauf_vorhanden"
                             data-name="gruppe_stammdaten_2_rechtsschutz_bei_kauf_vorhanden" @change="update($event);sendGaEvent($event)" required/>
                      <label for="rsv_no">Nein</label>
                    </div>

                  </div>
                </div>

                <!-- rsv vorhanden = nein und KEIN Selbstzahler -->
<!--                <div v-if="rsv_bei_kauf_vorhanden == 'Nein' && !isSelbstzahler" class="row">-->
<!--                  <div class="col-12 text-center">-->
<!--                    <div class="alert alert-info mb-4" role="alert">-->
<!--                      <span class="hinweis-box-icon"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Hinweis</span>-->
<!--                      <span class="hinweis-text-block">Ohne Rechtsschutzversicherung zum Zeitpunkt des Kaufes können wir Ihnen aktuelle ein weiteres Vorgehen nicht empfehlen.-->
<!--                        Das Kostenrisiko schätzen wir bei der derzeitigen Situation vor den Gerichten als zu hoch ein. Dies kann sich jedoch durch positive Urteile jederzeit ändern.-->
<!--                        Gerne informieren wir Sie im Weg unserer Warteliste <strong>kostenlos</strong> und <strong>unverbindlich</strong> über alle Entwicklungen und Ihre Chancen.</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

                <!-- rsv vorhanden = nein und IST Selbstzahler -->
<!--                <div v-if="rsv_bei_kauf_vorhanden == 'Nein' && isSelbstzahler" class="row">-->
<!--                  <div class="col-12 text-center">-->
<!--                    <div class="alert alert-info mb-4" role="alert">-->
<!--                      <span class="hinweis-box-icon"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Vielen Dank</span>-->
<!--                      <span class="hinweis-text-block">In Ihrem Fall bestehen auch ohne Rechtsschutzversicherung <strong>gute Erfolgsaussichten</strong>. Bevor wir mit einer Bearbeitung beginnen beraten wir Sie kostenlos telefonisch zu ihre Optionen. Bitte füllen Sie hierzu das Formular weiter aus.-->
<!--                      </span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

                <!-- rsv vorhanden = ja -->
                <div v-if="rsv_bei_kauf_vorhanden == 'Ja'">
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <label>Name der Rechtsschutzversicherung</label>
                      <div class="rueden-input mb-2">
                        <vue-simple-suggest @select="updateRSV"
                                            :list="rsv_synonyme"
                                            :min-length="1"
                                            :max-suggestions="0"
                                            :filter-by-query="true">
                          <input @change="update($event);sendGaEvent($event)"
                                 ref="rsv_bei_kauf_name"
                                 @focus="sendGaEvent"
                                 class="form-control"
                                 v-model="rsv_bei_kauf_name"
                                 type="text"
                                 name="gruppe_stammdaten_2_rsv_bei_kauf_name"
                                 data-name="gruppe_stammdaten_2_rsv_bei_kauf_name"
                          />
                        </vue-simple-suggest>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <label>Ihre Versicherungsnummer</label>
                      <div class="rueden-input mb-2">
                        <input @focus="sendGaEvent" class="form-control" type="text" v-model="rsv_bei_kauf_nummer"
                               data-name="gruppe_stammdaten_2_rsv_bei_kauf_nummer" @change="update($event);sendGaEvent($event)"/>
                        <!-- kein Pflichtfeld -->
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="alert alert-secondary mb-4" role="alert">
                        Sollten Sie den Namen und die Nummer Ihrer Versicherung aktuell nicht vorliegen haben, können
                        Sie uns diese gerne später per E-Mail an <strong>info@rueden.de</strong> nachreichen.
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-7 col-lg-7 col-xl-8 pr-0">
                      <p class="form-question">Besteht immer noch die gleiche Versicherung?
                      </p>
                    </div>
                    <div class="col-12 col-md-5 col-lg-5 col-xl-4 text-right mobile-md-text-left">
                      <div class="form-checkboxes form-display-inline">
                        <input type="radio" id="same_rsv_yes" value="Ja" v-model="rsv_besteht_noch"
                               name="rsv_besteht_noch" data-name="gruppe_stammdaten_2_rsv_besteht_noch" @change="update($event);sendGaEvent($event)"
                               required/>
                        <label for="same_rsv_yes" class="">Ja</label>
                      </div>
                      <div class="form-checkboxes form-display-inline">
                        <input type="radio" id="same_rsv_no" value="Nein" v-model="rsv_besteht_noch"
                               name="rsv_besteht_noch" data-name="gruppe_stammdaten_2_rsv_besteht_noch" @change="update($event);sendGaEvent($event)"
                               required/>
                        <label for="same_rsv_no" class="">Nein</label>
                      </div>
                    </div>
                  </div>

                  <!-- Auto für berufliche zwecke gekauft = Ja -->
                  <div v-if="gewerbliche_nutzung == 'Ja'" class="row">
                    <div class="col-12 col-md-7 col-lg-7 col-xl-8 pr-0">
                      <p class="form-question">Erstreckt sich die Versicherung auch auf Ihre selbstständige Tätigkeit?
                      </p>
                    </div>
                    <div class="col-12 col-md-5 col-lg-5 col-xl-4 text-right mobile-md-text-left">
                      <div class="form-checkboxes form-display-inline">
                        <input type="radio" id="selbststaendig_rsv_yes" value="Ja" v-model="selbststaendig_rsv"
                               name="selbststaendig_rsv" data-name="selbststaendig_rsv" @change="update($event);sendGaEvent($event)" required/>
                        <label for="selbststaendig_rsv_yes" class="">Ja</label>
                      </div>
                      <div class="form-checkboxes form-display-inline">
                        <input type="radio" id="selbststaendig_rsv_no" value="Nein" v-model="selbststaendig_rsv"
                               name="selbststaendig_rsv" data-name="selbststaendig_rsv" @change="update($event);sendGaEvent($event)" required/>
                        <label for="selbststaendig_rsv_no" class="">Nein</label>
                      </div>
                    </div>
                  </div>

                  <!-- Auto für berufliche zwecke gekauft = Nein -->
                  <div v-if="gewerbliche_nutzung == 'Nein'">
                    <div class="row">
                      <div class="col-12 col-md-7 col-lg-7 col-xl-8 pr-0">
                        <p class="form-question">Sind Sie selbst der/die Versicherungsnehmer/in?
                        </p>
                      </div>
                      <div class="col-12 col-md-5 col-lg-5 col-xl-4 text-right mobile-md-text-left">
                        <div class="form-checkboxes form-display-inline">
                          <input type="radio" id="mandant_ist_rsv_vertragspartner_yes" value="Ja"
                                 v-model="mandant_ist_rsv_vertragspartner" name="mandant_ist_rsv_vertragspartner"
                                 data-name="mandant_ist_rsv_vertragspartner" @change="update($event);sendGaEvent($event)" required/>
                          <label for="mandant_ist_rsv_vertragspartner_yes" class="">Ja</label>
                        </div>
                        <div class="form-checkboxes form-display-inline">
                          <input type="radio" id="mandant_ist_rsv_vertragspartner_no" value="Nein"
                                 v-model="mandant_ist_rsv_vertragspartner" name="mandant_ist_rsv_vertragspartner"
                                 data-name="mandant_ist_rsv_vertragspartner" @change="update($event);sendGaEvent($event)" required/>
                          <label for="mandant_ist_rsv_vertragspartner_no" class="">Nein</label>
                        </div>
                      </div>
                    </div>

                    <!-- Bin ich der Versicherungsnehmer = nein -->
                    <div v-if="mandant_ist_rsv_vertragspartner == 'Nein'">
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <label>Wer ist der/die Versicherungsnehmer/in?</label>
                          <div class="control-select">
                            <select v-model="rsv_vertragspartner" name="rsv_vertragspartner" data-name="rsv_vertragspartner" @change="update($event);sendGaEvent($event)" required>
                              <option v-for="option in versicherungsnehmer_options" v-bind:value="option.value" :key="option.value">
                                {{ option.text }}
                              </option>
                            </select>
                            <div class="select-arrow"></div>
                          </div>
                        </div>
                      </div>

                      <div v-if="rsv_vertragspartner == 'Mein/e Partner/in'" class="row">
                        <div class="col-12 col-md-7 col-lg-7 col-xl-8 pr-0">
                          <p class="form-question">Lebten Sie mit Ihrer/m Partner/in zum Kaufzeitpunkt in einem
                            gemeinsamen Haushalt?
                          </p>
                        </div>
                        <div class="col-12 col-md-5 col-lg-5 col-xl-4 text-right mobile-md-text-left">
                          <div class="form-checkboxes form-display-inline">
                            <input type="radio" id="partner_rsv_yes" value="Ja"
                                   v-model="rsv_mit_partner_bei_kauf_in_haus_gewohnt"
                                   name="rsv_mit_partner_bei_kauf_in_haus_gewohnt"
                                   data-name="rsv_mit_partner_bei_kauf_in_haus_gewohnt" @change="update($event);sendGaEvent($event)" required/>
                            <label for="partner_rsv_yes" class="">Ja</label>
                          </div>
                          <div class="form-checkboxes form-display-inline">
                            <input type="radio" id="partner_rsv_no" value="Nein"
                                   v-model="rsv_mit_partner_bei_kauf_in_haus_gewohnt"
                                   name="rsv_mit_partner_bei_kauf_in_haus_gewohnt"
                                   data-name="rsv_mit_partner_bei_kauf_in_haus_gewohnt" @change="update($event);sendGaEvent($event)" required/>
                            <label for="partner_rsv_no" class="">Nein</label>
                          </div>
                        </div>
                      </div>

                      <div v-if="rsv_vertragspartner == 'Meine Eltern'">

                        <div class="row">
                          <div class="col-12 col-md-7 col-lg-7 col-xl-8 pr-0">
                            <p class="form-question">Waren Sie zum Zeitpunkt des Kaufs verheiratet oder befanden Sie
                              sich in einer eingetragene Lebenspartnerschaft?
                            </p>
                          </div>
                          <div class="col-12 col-md-5 col-lg-5 col-xl-4 text-right mobile-md-text-left">
                            <div class="form-checkboxes form-display-inline">
                              <input type="radio" id="gemeinschaft_rsv_yes" value="Ja"
                                     v-model="rsv_bei_kauf_verheiratet_oder_eingetragene_lebenspartnerschaft"
                                     name="rsv_bei_kauf_verheiratet_oder_eingetragene_lebenspartnerschaft"
                                     data-name="rsv_bei_kauf_verheiratet_oder_eingetragene_lebenspartnerschaft"
                                     @change="update($event);sendGaEvent($event)" required/>
                              <label for="gemeinschaft_rsv_yes" class="">Ja</label>
                            </div>
                            <div class="form-checkboxes form-display-inline">
                              <input type="radio" id="gemeinschaft_rsv_no" value="Nein"
                                     v-model="rsv_bei_kauf_verheiratet_oder_eingetragene_lebenspartnerschaft"
                                     name="rsv_bei_kauf_verheiratet_oder_eingetragene_lebenspartnerschaft"
                                     data-name="rsv_bei_kauf_verheiratet_oder_eingetragene_lebenspartnerschaft"
                                     @change="update($event);sendGaEvent($event)" required/>
                              <label for="gemeinschaft_rsv_no" class="">Nein</label>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12 col-md-7 col-lg-7 col-xl-8 pr-0">
                            <p class="form-question">Befanden Sie sich zum Kaufdatum noch in der Erstausbildung?
                            </p>
                          </div>
                          <div class="col-12 col-md-5 col-lg-5 col-xl-4 text-right mobile-md-text-left">
                            <div class="form-checkboxes form-display-inline">
                              <input type="radio" id="rsv_bei_kauf_in_erstausbildung_yes" value="Ja"
                                     v-model="rsv_bei_kauf_in_erstausbildung" name="rsv_bei_kauf_in_erstausbildung"
                                     data-name="rsv_bei_kauf_in_erstausbildung" @change="update($event);sendGaEvent($event)" required/>
                              <label for="rsv_bei_kauf_in_erstausbildung_yes" class="">Ja</label>
                            </div>
                            <div class="form-checkboxes form-display-inline">
                              <input type="radio" id="rsv_bei_kauf_in_erstausbildung_no" value="Nein"
                                     v-model="rsv_bei_kauf_in_erstausbildung" name="rsv_bei_kauf_in_erstausbildung"
                                     data-name="rsv_bei_kauf_in_erstausbildung" @change="update($event);sendGaEvent($event)" required/>
                              <label for="rsv_bei_kauf_in_erstausbildung_no" class="">Nein</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                <div class="row">
                  <div class="col-12 mt-4">
                    <!-- v-if="rsv_bei_kauf_vorhanden != 'Nein' || isSelbstzahler" -->
                    <button id="to-step-4" type="submit" @click="sendGaEvent($event);nextStep(3)"
                            class="btn btn-primary-blue">weiter &nbsp; <i class="fa fa-angle-double-right"
                                                                          aria-hidden="true"></i></button>
<!--                    <button id="auf-warteliste" type="button" @click="sendGaEvent($event);inWartelisteEintragen()" v-if="rsv_bei_kauf_vorhanden == 'Nein'  && !isSelbstzahler"-->
<!--                            class="btn btn-primary-blue">In die Warteliste eintragen &nbsp; <i-->
<!--                        class="fa fa-angle-double-right" aria-hidden="true"></i></button>-->
                  </div>
                </div>

              </div>
            </div>
          </div>

          <input type="submit" id="hidden_submit_2" value="jetzt"/>

        </form>
      </div>

      <!-- 4. Vollmacht -->
      <div class="container pt-5 pb-5" v-if="schritt === 4">
        <form id="form_4" autocomplete="off">

          <Schrittanzeige :schritt="4"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">

              <div class="formular-box">
                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0 pb-5">4. Erteilung der Vollmacht</h2>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="form-checkboxes form-display-inline">
                      <input type="checkbox" :checked="zustimmung_vollmacht === 'Ja'" id="vollmachtThirdCheck"
                             v-model="zustimmung_vollmacht" name="zustimmung_vollmacht" data-value="Ja" data-name="zustimmung_vollmacht"
                             @change="update($event);sendGaEvent($event)" required/>
                      <label for="vollmachtThirdCheck" class=""><strong>Hiermit erteile ich den Rechtsanwält/innen der
                        Kanzlei VON RUEDEN – Partnerschaft von Rechtsanwälten, Leipziger Platz 9, 10117 Berlin</strong>,
                        wegen der angegebenen Abgasskandalsache Vollmacht zur außergerichtlichen Vertretung aller
                        Art als auch Prozessvollmacht für alle Verfahren in allen Instanzen gegen alle in Frage
                        kommenden Gegner. Der Bevollmächtigte ist zur Übertragung dieser Vollmacht ganz oder teilweise
                        befugt.</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <p class="">
                      <strong>Diese Vollmacht erstreckt sich insbesondere auf:</strong>
                    </p>
                    <ol class="number-list">
                      <li>
                        die außergerichtlichen Vertretung,
                      </li>
                      <li>
                        die Begründung und Aufhebung von Vertragsverhältnissen und zur Abgabe und Entgegennahme von
                        einseitigen Willenserklärungen in jedem Verfahren sowie in außergerichtlichen Verhandlungen,
                      </li>
                      <li v-if="rsv_bei_kauf_vorhanden == 'Ja'">
                        die außergerichtlichen Durchsetzung des Deckungsanspruchs gegenüber Rechtsschutzversicherungen,
                        beispielsweise durch Stichentscheid und
                      </li>
                      <li v-else>
                        den Abschluss von Verträgen mit einem Prozessfinanzierer nach Rücksprache mit dem Vollmachtgeber und
                      </li>
                      <li>
                        die Prozessführung sowie zur Vertretung in sonstigen Verfahren, insbesondere vor Behörden,
                        einschließlich der Vorverfahren und der verwaltungsgerichtlichen Verfahren sowie zur
                        Empfangnahme von Schriftstücken, sonstigem Schriftverkehr sowie aller Gelder. Der vorgenannte
                        Vertreter ist umfassend unterrichtet, zur Aufklärung des Tatbestandes in der Lage und zur Abgabe
                        der gebotenen Erklärungen, insbesondere zu einem Vergleichsabschluss ermächtigt.
                      </li>
                    </ol>
                  </div>
                </div>

								<div class="row">

                  <div class="col-12">
                    <div class="form-checkboxes form-display-inline">
                      <input type="checkbox" :checked="zustimmung_datenschutz_und_widerruf === 'Ja'" id="vollmachtFirstCheck"
                             v-model="zustimmung_datenschutz_und_widerruf" name="zustimmung_datenschutz_und_widerruf"
                             data-name="zustimmung_datenschutz_und_widerruf" data-value="Ja" @change="update($event);sendGaEvent($event)" required/>
                      <label for="vollmachtFirstCheck">Ich habe die <a href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a>
                        und die <a href="#" v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</a> gelesen und bin
                        damit einverstanden.</label>
                    </div>
                  </div>

                  <div v-if="['Goldberg Automobile GmbH'].includes(quelle)" class="col-12">
                    <div class="form-checkboxes form-display-inline">
                      <input type="checkbox" :checked="checkbox_schweigepflichtentbindung === 'Ja'" id="schweigepflichtentbindungCheck"
                             v-model="checkbox_schweigepflichtentbindung" name="checkbox_schweigepflichtentbindung"
                             data-name="checkbox_schweigepflichtentbindung" data-value="Ja" @change="update($event);sendGaEvent($event)" required/>
                      <label for="schweigepflichtentbindungCheck">Hiermit entbinde ich VON RUEDEN von der anwaltlichen Schweigepflicht gegenüber {{quelle}}.</label>
                    </div>
                  </div>

								</div>

                <div class="row mt-4">
                  <div class="col-12">

                    <div class="unterschrift d-none">

                      <!-- Automatische Unterschrift -->
                      <div id="unterschrift_automatisch" v-if="vorname && unterschrift_typ == 'automatisch'">
                        <div class="bg-white p-3">
                          <div style="max-width:420px">
                            <span style="font-weight:bold; font-size:300%; float: left; margin-right:20px;">X</span>
                            <span class="schreibschrift" style="float:left; margin-top:17px;">{{
                                vorname.substr(0, 1)
                              }}. {{ nachname }}</span>
                            <div class="clearfix"></div>
                            <hr/>
                          </div>
                        </div>
                      </div>

                      <!-- Manuelle Unterschrift -->
                      <div id="unterschrift_manuell" v-if="unterschrift_typ == 'manuell'">

                        <div class="bg-white mb-2 p-3">
                          <div style="max-width:420px;">
                            <div style="border: solid 1px #ddd; margin-bottom: 10px;">
                              <VueSignaturePad width="380px" height="200px" ref="signaturePad" :options="{onEnd}"/>
                            </div>
                            <span @click="clearSignature()" class="cursor-pointer"><i
                                class="fa fa-remove text-danger"></i> Unterschrift erneut eingeben </span>
                          </div>
                        </div>

                      </div>

                      <div class="row mt-3">
                        <div class="col-lg-6">
                          <i class="fa fa-check-circle text-success"></i> Diese Unterschrift ist ausreichend
                        </div>
                        <div class="col-lg-6 text-right">
													<span class="cursor-pointer" @click="changeSignatureMode()">
														<i class="fa fa-edit text-danger "></i> Mit Finger / Maus unterschreiben
													</span>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12 mt-4">
                    <button id="vollmacht-erteilen" @click="sendGaEvent($event);verifyVM()" type="submit" class="btn btn-primary-blue">Vollmacht &amp; Mandat
                      erteilen &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <input type="submit" id="hidden_submit_4" value="jetzt"/>

        </form>
      </div>

      <!-- 5. PKW Daten -->
      <div class="container pt-5 pb-5" v-if="schritt === 5">
        <form id="form_5" autocomplete="off">

          <Schrittanzeige :schritt="5"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">
              <div class="formular-box">
                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0 pb-5">5. Angaben zum Kauf des Fahrzeugs</h2>
                  </div>
                </div>

                <div class="row" v-if="kraftstoff == 'Diesel'">
                  <div class="col-12 col-md-7 pr-0">
                    <p class="form-question">Hat das Fahrzeug einen Ad-Blue-Tank? <a v-tooltip="{ content: 'Wenn Sie sich nicht sicher sind, öffnen Sie bitte Ihren Tankdeckel. Sollte dort ein zusätzlicher blauer Deckel sein, hat Ihr Fahrzeug einen Ad-Blue-Tank (Harnstofftank).', trigger: 'click' }">
                      <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                    </a></p>

                  </div>
                  <div class="col-12 col-md-5 text-right mobile-md-text-left">
                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="tank_yes" value="Ja" v-model="ad_blue_tank"
                             name="fahrzeug_ad_blue" data-name="fahrzeug_ad_blue"
                             @change="update($event);sendGaEvent($event)" required/>
                      <label for="tank_yes">Ja</label>
                    </div>
                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="tank_no" value="Nein" v-model="ad_blue_tank"
                             name="fahrzeug_ad_blue" data-name="fahrzeug_ad_blue"
                             @change="update($event);sendGaEvent($event)" required/>
                      <label for="tank_no">Nein</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <label for="finanzierungsart">Wie haben Sie das Fahrzeug finanziert?</label>
                    <div class="control-select">
                      <select v-model="finanzierungsart" name="finanzierungsart" data-name="finanzierungsart"
                              @change="update($event);sendGaEvent($event)" id="finanzierungsart" required>
                        <option v-for="option in finanzierung_options" v-bind:value="option.value" :key="option.value">
                          {{ option.text }}
                        </option>
                      </select>
                      <div class="select-arrow"></div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="rueden-input">
                      <label>Wie hoch war der Kaufpreis?</label>
                      <div class="pos-relative">
                        <input @focus="sendGaEvent" class="form-control" type="text" v-model="kaufpreis" name="kaufpreis"
                               data-name="pkw_gruppe_2_kaufpreis" @change="update($event);sendGaEvent($event)" required/>
                        <span class="input-type-info">EUR</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-7 pr-0">
                    <p class="form-question">Haben Sie das Fahrzeug noch?</p>
                  </div>
                  <div class="col-12 col-md-5 text-right mobile-md-text-left">
                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="besitz_yes" value="Ja" v-model="fahrzeug_noch_in_besitz"
                             name="fahrzeug_noch_in_besitz" data-name="pkw_gruppe_2_fahrzeug_noch_in_besitz"
                             @change="update($event);sendGaEvent($event)" required/>
                      <label for="besitz_yes">Ja</label>
                    </div>
                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="besitz_no" value="Nein" v-model="fahrzeug_noch_in_besitz"
                             name="fahrzeug_noch_in_besitz" data-name="pkw_gruppe_2_fahrzeug_noch_in_besitz"
                             @change="update($event);sendGaEvent($event)" required/>
                      <label for="besitz_no">Nein</label>
                    </div>
                  </div>
                </div>

                <div v-if="fahrzeug_noch_in_besitz === 'Nein'" class="row">
                  <div class="col-12 col-md-6">
                    <div class="rueden-input">
                      <label>Wie viel haben Sie für das Fahrzeug bei Weiterverkauf erhalten?</label>
                      <div class="pos-relative">
                        <input @focus="sendGaEvent" class="form-control" type="text" v-model="verkaufspreis" name="verkaufspreis"
                               data-name="verkaufspreis" @change="update($event);sendGaEvent($event)" required />
                        <span class="input-type-info">EUR</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="rueden-input">
                      <label>
                        Welchen Kilometerstand hatte das Fahrzeug zuletzt?
                        <a v-tooltip="{ content: 'Wir benötigen die Kilometerstände zur Berechnung des Rückerstattungsbetrags.', trigger: 'click' }">
                          <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                        </a>
                      </label>
                      <div class="pos-relative">
                        <input @focus="sendGaEvent" class="form-control" type="text" v-model="km_stand_aktuell" name="km_stand_aktuell"
                               data-name="pkw_gruppe_2_km_stand_aktuell" @change="update($event);sendGaEvent($event)" required/>
                        <span class="input-type-info">km</span>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="rueden-input">
                      <label>
                        Bei welchem Kilometerstand haben Sie das Fahrzeug erworben?
                        <a v-tooltip="{ content: 'Diese Angabe finden Sie im Kaufvertrag oder in der Bestellung.', trigger: 'click' }">
                          <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                        </a>
                      </label>
                      <div class="pos-relative">
                        <input @focus="sendGaEvent" class="form-control" type="text" v-model="km_stand_bei_kauf" name="km_stand_bei_kauf"
                               data-name="pkw_gruppe_2_km_stand_bei_kauf" @change="update($event);sendGaEvent($event)" required/>
                        <span class="input-type-info">km</span>
                      </div>
                    </div>

                  </div>
                  <div v-if="fahrzeug_noch_in_besitz == 'Ja'" class="col-12 col-md-6">
                    <div class="rueden-input">
                      <label>
                        Welchen Kilometerstand hat Ihr Fahrzeug aktuell?
                        <a v-tooltip="{ content: 'Bitte geben Sie einen möglichst aktuellen Kilometerstand an.', trigger: 'click' }">
                          <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                        </a>
                      </label>
                      <div class="pos-relative">
                        <input @focus="sendGaEvent" class="form-control" type="text" v-model="km_stand_aktuell" name="km_stand_aktuell"
                               data-name="pkw_gruppe_2_km_stand_aktuell" @change="update($event);sendGaEvent($event)" required/>
                        <span class="input-type-info">km</span>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col-12 mt4">
                    <button id="to-step-6" @click="sendGaEvent($event);nextStep(5)" type="submit" class="btn btn-primary-blue">weiter &nbsp; <i
                        class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <input type="submit" id="hidden_submit_5" value="jetzt"/>

        </form>
      </div>

      <!-- 6. Dokumente  -->
      <div class="container pt-5 pb-5" v-if="schritt === 6">
        <form id="form_6" autocomplete="off">

          <Schrittanzeige :schritt="6"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">
              <div class="formular-box">
                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0 pb-5">6. Upload der Dokumente</h2>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <h3 class="form-title-3">
                      Bitte laden Sie nun die nachfolgenden Dokumente hoch. Klicken Sie dazu einfach auf das <i class="fa fa-plus-circle text-primary"></i> Symbol
                      neben dem entsprechenden Dokument.
                    </h3>
                    <span class="d-none">Sie können die Dateien auch zu einem späteren Zeitpunkt hochladen. Kehren Sie einfach zu dieser Seite zurück.</span>

                    <table class="table table-sm table-striped mt-3">

                      <thead class="btn-primary-blue text-white w-100">
                      <tr>
                        <th width="65%">Dokument</th>
                        <th></th>
                        <th></th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr>
                        <td class="pb-4">Kaufvertrag oder verbindliche Bestellung oder Rechnung <br/><span
                            class="upload-italic-text">(<strong>bitte vollständig - alle Seiten</strong>)</span></td>
                        <td>

                          <i id="kaufvertrag-bestellung-rechnung-desktop" @click="sendGaEvent($event);chooseFile('kaufvertrag-bestellung-rechnung')"
                             class="d-none d-md-block fa fa-plus-circle cursor-pointer text-primary fa-2x"></i>

                        </td>
                        <td>

                          <i id="kaufvertrag-bestellung-rechnung-mobile" @click="sendGaEvent($event);chooseFile('kaufvertrag-bestellung-rechnung')"
                             class="d-block d-md-none fa fa-plus-circle cursor-pointer text-primary fa-2x"></i>

														<span v-if="files_kaufvertrag_bestellung_rechnung > 0">
															{{ files_kaufvertrag_bestellung_rechnung }} Datei(en)
														</span>
                          <span v-else>Noch nicht hochgeladen</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="pb-4">
                          Fahrzeugschein (Zulassungsbescheinigung Teil I)<br/><span class="upload-italic-text">(Bitte nur die <label v-on:click="toggleCheck = !toggleCheck" style="text-decoration: underline;color: #789a3f; cursor: pointer"> Vorderseite <input class="d-none" type="checkbox" v-on:change="toggleCheck = !toggleCheck" :value="toggleCheck" /></label>)</span><br />
                          <transition name="slide">
                           <div v-if="toggleCheck">
                            <img style="max-width: 100%" alt="Zulassungsbescheinigung" src="../../assets/img/zulassungsbescheinigung.jpg" />
                           </div>
                         </transition>
                        </td>
                        <td>
                          <i id="fahrzeugschein-zb-1-desktop" @click="sendGaEvent($event);chooseFile('fahrzeugschein-zb-1')"
                               class="d-none d-md-block fa fa-plus-circle cursor-pointer text-primary fa-2x"></i>
                        </td>
                        <td>
                          <i id="fahrzeugschein-zb-1-mobile" @click="sendGaEvent($event);chooseFile('fahrzeugschein-zb-1')"
                             class="d-block d-md-none fa fa-plus-circle cursor-pointer text-primary fa-2x"></i>

														<span v-if="files_fahrzeugschein_zb_1> 0">
															{{ files_fahrzeugschein_zb_1 }} Datei(en)
														</span>
                          <span v-else>Noch nicht hochgeladen</span>
                        </td>
                      </tr>
                      <tr v-if="finanzierungsart === 'Darlehen'">
                        <td class="pb-4">
                          Darlehensvertrag/-antrag und Tilgungsplan <a v-tooltip="{ content: 'Folgendes <strong>muss</strong> nachvollziehbar sein: Gesamtpreis, Höhe der Raten, Höhe und Datum der Anzahlung, Datum der ersten Rate', trigger: 'click' }">
                            <i class="fa fa-question-circle-o" aria-hidden="true"></i></a><br/><span class="upload-italic-text">(Bitte senden Sie uns alle Seiten der Dokumente)</span>
                        </td>
                        <td>
                          <i id="darlehen-desktop" @click="sendGaEvent($event);chooseFile('darlehen')"
                               class="d-none d-md-block fa fa-plus-circle cursor-pointer text-primary fa-2x"></i>
                        </td>

                        <td>

                          <i id="darlehen-mobile" @click="sendGaEvent($event);chooseFile('darlehen')"
                             class="d-block d-md-none fa fa-plus-circle cursor-pointer text-primary fa-2x"></i>

														<span v-if="files_darlehen">
															{{ files_darlehen }} Datei(en)
														</span>
                          <span v-else>Noch nicht hochgeladen</span>
                        </td>
                      </tr>
                      <!--<tr v-if="rsv_bei_kauf_vorhanden == 'Nein' && !automarke.toLowerCase().includes('mercedes')">
                        <td class="pb-4">Rückrufschreiben</td>
                        <td>
                          <i id="rueckrufschreiben-desktop" @click="sendGaEvent($event);chooseFile('rueckrufschreiben')"
                             class="d-none d-md-block fa fa-plus-circle cursor-pointer text-primary fa-2x"></i>
                        </td>
                        <td>

                          <i id="rueckrufschreiben-mobile" @click="sendGaEvent($event);chooseFile('rueckrufschreiben')"
                             class="d-block d-md-none fa fa-plus-circle cursor-pointer text-primary fa-2x"></i>

                          <span v-if="files_rueckrufschreiben > 0">
															{{ files_rueckrufschreiben }} Datei(en)
														</span>
                          <span v-else>Noch nicht hochgeladen</span>
                        </td>
                      </tr>-->

                      </tbody>
                    </table>

                  </div>
                </div>

                <div class="row pb-4">
                  <div class="col-12 pt-3">

                    <button
                        v-if="((files_fahrzeugschein_zb_1 > 0 && files_kaufvertrag_bestellung_rechnung > 0) || (files_darlehen > 0 && files_fahrzeugschein_zb_1 > 0))"
                        @click="sendGaEvent($event);formularSchliessen()"
                        type="button"
                        id="formular-fertig"
                        class="btn btn-primary-blue"> Fertig</button>

                    <button v-else
                            v-tooltip="{ content: 'Um das Formular fertigzustellen, laden Sie bitte alle oben aufgeführten Dokumente hoch.', trigger: 'click' }"
                            type="button" class="btn btn-primary disabled">Fertig
                    </button>

                  </div>
                </div>

                <!-- Modal START -->
                <div class="modal d-block" tabindex="-1" v-if="showFertigstellungModal">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">Fragenbogen fertigstellen</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showFertigstellungModal = !showFertigstellungModal">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <p>Wenn Sie alle Ihnen vorliegenden Dokumente hochgeladen haben, bestätigen Sie
                          diese bitte mit 'Ja'. Unser Team wird per E-Mail darüber informiert und das
                          Ausfüllen des Fragebogens ist damit beendet.</p>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="showFertigstellungModal = !showFertigstellungModal">Nein, ich möchte noch
                          weitere Dokumente hochladen
                        </button>
                        <button type="button" class="btn btn-success">Ja</button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Modal ENDE -->

                <div class="row">
                  <div class="col-12 mt-3">
                    <div class="alert alert-info" role="alert">
                      <span class="hinweis-box-icon d-inline"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                      Sie können die Dateien auch zu einem späteren Zeitpunkt hochladen. Kehren Sie einfach später
                      erneut zu diesem Formular zurück.
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 order-2 col-sm-4 order-sm-1 mt-4 d-none">
                    <span @click="prevStep()" class="text-primary cursor-pointer"><i class="fa fa-angle-double-left" aria-hidden="true"></i> &nbsp; zurück</span>
                  </div>
                  <div class="col-12 oder-1 col-sm-8 order-sm-2 mt-4 text-right mobile-sm-text-left d-none">
                    <button type="button" class="btn btn-primary-blue">Abschicken &nbsp; <i
                        class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <input type="submit" id="hidden_submit_6" value="jetzt"/>

        </form>
      </div>

    </div>

    <!-- 7. Alles eingereicht -->
    <div v-if="status_ordner == 'Vollmacht eingegangen'">

      <div class="row mb-5">
        <div class="col-12 col-lg-8 offset-lg-2">
          <div class="formular-box">
            <div class="row">
              <div class="col-12 text-center">

                <div class="alert alert-info">
                <h2 class="mt-0 pt-0 mb-0 pb-4">Vielen Dank</h2>


								<p class="lead">Sie haben erfolgreich alle notwendigen Angaben übermittelt.</p>
 
								<p class="lead">Wie geht es weiter?

                  <span>Wir stellen für Sie im nächsten Schritt die Deckung der Verfahrenskosten sicher.
                    Hierdurch entstehen Ihnen keine Kosten. Wenn die Abdeckung der Verfahrenskosten bestätigt ist, veranlassen wir alles Weitere. Wir halten Sie per E-Mail über alle Schritte auf dem Laufenden.</span>

                <p class="lead">Bei Rückfragen schreiben Sie uns gerne an <a href="mailto:info@rueden.de">info@rueden.de</a>.</p>

                <div class="alert alert-info" v-if="!files_rueckrufschreiben">
										<div class="mb-3">
											<strong><span class="d-inline mr-1"><i class="fa fa-exclamation-circle"></i></span> Hinweis</strong>
										</div>
										<div class="mb-3">
											Hinweis -  Sollte Ihnen ein Rückrufschreiben oder eine Benachrichtigung einer freiwilligen Kundendienstmaßnahme vorliegen, erhöht das Ihre Erfolgschancen erheblich. Bitte laden Sie das Schreiben hier noch hoch.
										</div>
										<button id="rueckrufschreiben-hochladen" type="button" @click="chooseFile('rueckrufschreiben')" class="btn btn-outline-primary">
											<i class="fa fa-plus-circle"></i> Rückrufschreiben hochladen
										</button>
									</div>

                <div v-else-if="rsv_bei_kauf_vorhanden == 'Ja'"><em>Vielen Dank. Wir haben Ihr Rückrufschreiben erhalten.</em></div>

              </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Warteliste -->
    <div v-if="warteliste == 'Ja'">

      <div class="container">

        <div class="row mb-5">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">
              <div class="row">
                <div class="col-12 text-center">

                  <div v-if="warteliste == 'Ja'">
                    <h2 class="mt-0 pt-0 mb-0 pb-4">Vielen Dank</h2>
                    <p class="lead">Sie haben sich für eine Eintragung in unsere Warteliste entschieden. Wir halten Sie auf dem laufenden über relevante Neuigkeiten und positive Änderungen Ihrer Erfolgschancen. </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!-- Footer -->
    <div class="col-12 mb-4">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 text-center text-secondary">
            VON RUEDEN Partnerschaft von Rechtsanwälten<br />
            <b-link v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</b-link> &middot; <a href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <Datenschutzerklaerung/>
    <Widerrufsbelehrung/>

		<!-- Upload File Input -->
		<input @change="uploadFile()" type="file" id="file" ref="file" class="d-none"/>

  </div>

</template>
<style>
.form-checkboxes {
  margin-bottom: 13px;
}
</style>
<script>

import axios from 'axios'
import Schrittanzeige from '../../components/abgasskandal/Schrittanzeige'
import Datenschutzerklaerung from '../Datenschutzerklaerung'
import Widerrufsbelehrung from '../Widerrufsbelehrung'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css' // Optional CSS
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {

  components: {Schrittanzeige, Datenschutzerklaerung, Widerrufsbelehrung, VueSimpleSuggest, VueGoogleAutocomplete},

  data() {
    return {

      // Url

      setUrl: "https://node.wvr-law.de/api/set/lead.php?security=b1c9ea4a72fe0a123728ac8c65d1ce33",

      // Schritt

      schritt: 1,
      formular_schritt: 1,

      // toggleContent
      toggleCheck: false,

      // Fragebogen

      status_ordner: null,
      anrede: null,
      vorname: null,
      nachname: null,
      gewerbliche_nutzung: null,
      email: null,
      land: 'Deutschland',
      land_options: [
        {text: 'Deutschland', value: 'Deutschland'},
        {text: 'Schweiz', value: 'Schweiz'},
        {text: 'Österreich', value: 'Österreich'},
      ],
      strasse: null,
      strasse_nummer: null,
      plz: null,
      address_google: null,
      address_empty: false,
      address_missingNo: false,
      ort: null,
      telefon: null,

      unterschrift: null,
      unterschrift_typ: "automatisch",

      quelle: null,

      name_des_kaeufers_im_kaufvertrag: null,
      kaeufer_auto: null, // Feld in Todo nachtragen!

      zustimmung_datenschutz_und_widerruf: null,
      zustimmung_widerruf_verzicht: null,
      zustimmung_vollmacht: null,
      checkbox_schweigepflichtentbindung: null,

      auto: null, // Sinn?
      auto_vorhanden: null, // Feld in Todo nachtragen!
      automarke: null,
      automarke_options: [
        {text: 'Bitte auswählen', value: ''},
        {text: 'Audi', value: 'Audi'},
        {text: 'Mercedes-Benz', value: 'Mercedes-Benz'},
        {text: 'Opel', value: 'Opel'},
        {text: 'Porsche', value: 'Porsche'},
        {text: 'Seat', value: 'Seat'},
        {text: 'Skoda', value: 'Skoda'},
        {text: 'Volkswagen', value: 'Volkswagen'},
        {text: 'Volvo', value: 'Volvo'},
        {text: 'Sonstiges', value: 'Sonstiges'}
      ],
      modell: null,
      kraftstoff: null,
      kraftstoff_options: [
        {text: 'Bitte auswählen', value: ''},
        {text: 'Benzin', value: 'Benzin'},
        {text: 'Diesel', value: 'Diesel'}
      ],
      ad_blue_tank: null,
      kennzeichen: null,

      finanzierungsart: '',
      finanzierung_options: [
        {text: 'Bitte auswählen', value: ''},
        {text: 'Barkauf', value: 'Voll bezahlt'},
        {text: 'Finanzierung', value: 'Darlehen'},
        {text: 'Leasing', value: 'Leasing'},
        {text: 'Mietkauf', value: 'Mietkauf'}
      ],
      kaufpreis: null,
      fahrzeug_noch_in_besitz: null,
      verkaufspreis: null,

      km_stand_bei_kauf: null,
      km_stand_aktuell: null,

      rsv_bei_kauf_vorhanden: "Ja",
      rsv_bei_kauf_name: null,
      rsv_bei_kauf_nummer: null,

      rsv_warteliste: null, // Feld in Todo nachtragen!
      rsv_besteht_noch: null,
      mandant_ist_rsv_vertragspartner: null, // vormals: meine_rsv
      selbststaendig_rsv: null,

      rsv_vertragspartner: null,
      versicherungsnehmer_options: [
        {text: 'Bitte auswählen', value: null},
        {text: 'Mein/e Partner/in', value: 'Mein/e Partner/in'},
        {text: 'Meine Eltern', value: 'Meine Eltern'}
      ],
      rsv_bei_kauf_verheiratet_oder_eingetragene_lebenspartnerschaft: null,
      rsv_mit_partner_bei_kauf_in_haus_gewohnt: null,
      rsv_bei_kauf_in_erstausbildung: null,

      // Dateien

      api: "",
      api_vm_url: "https://node.wvr-law.de/api/set/lead.php?security=",
      uploadInProgress: false,
      file: null,
      docType: null,
      showFertigstellungModal: false,

      files_kaufvertrag_bestellung_rechnung: 0,
      files_darlehen: 0,
      files_fahrzeugschein_zb_1: 0,
      files_rueckrufschreiben: 0,

      docTypes: [
        'kaufvertrag_bestellung_rechnung',
        'darlehen',
        'fahrzeugschein_zb_1',
        'rueckrufschreiben'
      ],

      warteliste: "Nein"

    }
  },
  mounted() {

    // API
    if (process.env.VUE_APP_ENV === "dev") {
      this.api = "http://localhost:8000/api.php";
    } else {
      this.api = "https://formular.rueden.de/api";
    }

    var _this = this;

    // URL der API
    var token = this.$route.query.token;

    if (token === '' || token === undefined) {
      window.location.href = "https://www.rueden.de";
    } else {
      this.token = token;
    }

    // API Call

    let formData = new FormData();
    formData.append('action', 'get');
    formData.append('token', this.token);

    axios.post(this.api,
        formData,
        {headers: {'Content-Type': 'multipart/form-data'}})
        .then(function (response) {

          var data = response.data;

          // Werte in Felder eintragen
          Object.keys(data).forEach(function (key) {
            _this[key] = data[key];
          });

          if (data['status_ordner'] == "Warteliste") _this.warteliste = "Ja";

        }).then(function () {
      if (_this.formular_schritt) {
        _this.schritt = parseInt(_this.formular_schritt);
      }
    }).then(function () {
      _this.address_missingNo = true;
      if (_this['strasse']) {
        // let sParts = _this['strasse'].split(" ");
        // _this.address_missingNo = !(
        //     (sParts.length > 1 && /\d/.test(sParts[sParts.length-1]))
        //     || (sParts.length > 2 && /\d/.test(sParts[sParts.length-2]))
        //   );
        _this.address_google = _this['strasse'];
        // let prevAddress = _this['strasse'];
        // if (_this.ort) {
        //   if (_this.plz && _this.plz !== "undefined") {
        //     prevAddress = prevAddress + ", " + _this.plz + " " + _this.ort;
        //   } else {
        //     prevAddress = prevAddress + ", " + _this.ort;
        //   }
        // }
        // if (_this.land && _this.land !== "undefined") prevAddress = prevAddress + ", " + _this.land;
        // _this.address_google = prevAddress;
        // _this.address_google =
      }

    }).then(function() {
      _this.getUploadedFiles();
    });

    // Unterschrift immer löschen, wenn Schritt < 5
    if (this.schritt < 4) {
      this.unterschrift = "";
      this.update('unterschrift');
    }

  },
  methods: {
    // Schritte, Validierung

    nextStep(step) {

      if (this.validateForm(step)) {

        if (event) {
          event.preventDefault();
        }

        //var _this = this;

        this.schritt += 1;

        // Schritt speichern
        let formData = new FormData();
        formData.append('action', 'set');
        formData.append('token', this.token);
        formData.append('name', 'formular_schritt');
        formData.append('name_todo', 'formular_schritt');
        formData.append('value', this.schritt);
        axios.post(this.api, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(function () {
              // Vollmacht erstellen
              /*if (_this.schritt == 5) {
                axios.get(_this.api_vm_url + _this.token + '&create-vm=j');
              }*/
            });
      } else {
        //document.body.scrollTop = 0;
        //document.documentElement.scrollTop = 0;
        //alert('Bitte füllen Sie alle Felder aus');
        //document.getElementById("hidden_submit_" + this.schritt).click();
      }
    },

    prevStep() {
      if (this.schritt > 1) {
        this.schritt -= 1;
      }
    },

    validateForm(id) {
      var form = document.getElementById("form_" + id);
      if (!(this.strasse && this.plz && this.ort && this.land)) this.address_empty = true;
      return form.checkValidity();
    },

    updateRSV(rsv) {
      this.rsv_bei_kauf_name = rsv;
      // axios.get('https://flow.rueden.de/api/get/all-rsv/v2')
      //     .then(response => {
      //        if (response.data[0][rsv]) {
      //          this.rsv_bei_kauf_name = response.data[0][rsv];
      //        }
      //     });
      this.update(rsv);
      // Google Analytics
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      this.$gtag.event('change', {
        'event_category': devPrefix + "Abgas Personal Formular",
        'event_label': "gruppe_stammdaten_2_rsv_bei_kauf_name (text)"
      });
    },

    updateCarBrand(brand) {
      this.automarke = brand;
      this.updateToDo('automarke', 'pkw_gruppe_1_automarke', brand);
      // Google Analytics
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      this.$gtag.event('change', {
        'event_category': devPrefix + "Abgas Personal Formular",
        'event_label': "pkw_gruppe_1_automarke (text)"
      });
    },

    updateToDo(name, name_todo, value) {
      let formData = new FormData();
      formData.append('action', 'set');
      formData.append('token', this.token);
      formData.append('name', name);
      formData.append('name_todo', name_todo);
      formData.append('value', value);
      axios.post(this.api, formData, {headers: {'Content-Type': 'multipart/form-data'}});
    },

    // Speichern

    update(e) {

      var name;
      var name_todo;
      var value;

      // Normaler Aufruf (übergibt Event)
      if (e.target) {
        name = e.target.name;
        name_todo = e.target.getAttribute('data-name'); // Name in Todo
        value = e.target.value;

        // Wenn Attribut data-value existiert, dessen Wert nutzen
        if (e.target.getAttribute('data-value')) {
          value = e.target.getAttribute('data-value');
        }
      }

      // Sonderfälle
      else {

        // Unterschrift
        if (e === 'unterschrift') {
          name = "unterschrift";
          name_todo = "unterschrift";
          if (this.unterschrift === null || this.unterschrift === undefined) {
            value = "";
          } else {
            value = this.unterschrift;
          }
        } else if (e === 'vollmacht_eingegangen') {
          name = "status_ordner";
          name_todo = "status_ordner";
          value = "Vollmacht eingegangen";
        } else if (e === 'warteliste') {
          name = "status_ordner";
          name_todo = "status_ordner";
          value = "Warteliste";
          this.warteliste = "Ja";
        }

        // RSV Bei Kauf Name
        else {
          name = "gruppe_stammdaten_2_rsv_bei_kauf_name";
          name_todo = "gruppe_stammdaten_2_rsv_bei_kauf_name";
          value = e;
        }

      }

      this.updateToDo(name, name_todo, value);

    },

    // Signatur

    undo() {
      this.$refs.signaturePad.undoSignature();
    },

    save() {
      const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);
      console.log(data);
    },
    setStreetNumber() {
      // if (this.strasse_nummer) {
      //   this.strasse = this.strasse + ' ' + this.strasse_nummer;
      //   this.setGoogleAddress();
      //   this.$refs.addressGoogle.$el.value = this.address_google;
      //   this.address_missingNo = false;
      //   this.updateToDo('strasse', 'gruppe_stammdaten_1_strasse', this.strasse);
      //   if (!this.plz && this.strasse && this.ort && this.land) {
      //     var _this = this;
      //     var service = new window.google.maps.places.AutocompleteService();
      //     service.getPlacePredictions({ input: this.address_google, types: ['address'] }, function(predictions){
      //       var pID = predictions[0].place_id;
      //       var service2 = new window.google.maps.places.PlacesService(document.createElement('address_google'));
      //       service2.getDetails({fields:['address_components'], placeId:pID}, function(r) {
      //         r.address_components.forEach(function(c) {
      //           if (c.types.includes('postal_code')) {
      //             _this.plz = c.long_name;
      //             _this.setGoogleAddress();
      //             _this.$refs.addressGoogle.$el.value = _this.address_google;
      //             _this.updateToDo('plz', 'gruppe_stammdaten_1_plz', _this.plz);
      //           }
      //         });
      //       });
      //     });
      //   }
      // }

    },
    getAddressData: function (addressData) {
      this.address_empty = false;
      this.land = addressData.country;
      this.updateToDo('land', 'gruppe_stammdaten_1_land', this.land);
      this.ort = addressData.locality;
      this.updateToDo('ort', 'gruppe_stammdaten_1_ort', this.ort);
      if (addressData.postal_code) {
        this.plz = addressData.postal_code;
        this.updateToDo('plz', 'gruppe_stammdaten_1_plz', this.plz);
      }
      this.strasse = addressData.route;
      if (addressData.street_number) this.strasse = addressData.route  + ' ' + addressData.street_number;
      this.updateToDo('strasse', 'gruppe_stammdaten_1_strasse', this.strasse);
      this.address_google = this.strasse;
      this.$refs.addressGoogle.$el.value = this.strasse;

      //Google Analytics
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      this.$gtag.event('change', {
        'event_category': devPrefix + "Abgas Personal Formular",
        'event_label': "google-address (text)"
      });
    },

    blurGetAddressData() {
      // if (
      //     !this.strasse
      //     || !this.ort
      // ) {
      //   this.address_empty = true;
      //   this.$refs.addressGoogle.$el.value = "";
      // } else {
      //   this.setGoogleAddress();
      //   this.$refs.addressGoogle.$el.value = this.address_google;
      // }
      // this.address_missingNo = !this.strasse_nummer;
      // if (this.address_missingNo) setTimeout(() => {this.$refs.streetNumber.focus()});
      this.strasse = this.$refs.addressGoogle.$el.value;
      this.updateToDo('strasse', 'gruppe_stammdaten_1_strasse', this.strasse);
    },

    setGoogleAddress() {
      // let prevAddress = this.strasse;
      // if (prevAddress && this.ort) {
      //   if (this.plz) {
      //     prevAddress = prevAddress + ", " + this.plz + " " + this.ort;
      //   } else {
      //     prevAddress = prevAddress + ", " + this.ort;
      //   }
      // }
      // prevAddress = prevAddress + ", " + this.land;
      // this.address_google = prevAddress;
      // this.address_google = this.strasse;
    },
    clearAddresFields() {
      this.plz = null;
      this.strasse = null;
      this.ort = null;
      this.strasse_nummer = null;
      this.address_missingNo = false;
    },

    rsv_synonyme() {
      return axios.get('https://flow.rueden.de/api/get/all-rsv')
          .then(response => {
          return response.data[0];
        });
    },

    carBrands() {
      return axios.get('https://node.wvr-law.de/api/get/all-brands.php?security='+this.token)
          .then(response => {
            return response.data;
          });
    },

    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.unterschrift = this.$refs.signaturePad.saveSignature().data;
      this.update('unterschrift');
    },

    onEnd() {
      this.unterschrift = this.$refs.signaturePad.saveSignature().data;
      this.update('unterschrift');
    },

    changeSignatureMode() {
      if (this.unterschrift_typ == "automatisch") {
        this.unterschrift_typ = "manuell";
      } else {
        this.unterschrift_typ = "automatisch";
      }
    },

    chooseFile(docType) {
      this.docType = docType;
      document.getElementById('file').click();
    },

    uploadFile() {

      var _this = this;

      this.file = this.$refs.file.files[0];
      this.uploadInProgress = true;

      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('token', this.token);
      formData.append('docType', this.docType);

      axios.post('https://node.wvr-law.de/api/upload/upload.php', formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then(function () {
            _this.uploadInProgress = false;
            _this.getUploadedFiles();
          })
          .catch(function () {
            _this.uploadInProgress = false;
          });

    },

    getUploadedFiles() {

      let _this = this;
      let formData = new FormData();
      formData.append('token', this.token);
      formData.append('docTypes', this.docTypes);

      axios.post("https://node.wvr-law.de/api/upload/get-uploads.php",
          formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then(function (response) {
            _this.files_kaufvertrag_bestellung_rechnung = response.data.kaufvertrag_bestellung_rechnung;
            _this.files_darlehen = response.data.darlehen;
            _this.files_fahrzeugschein_zb_1 = response.data.fahrzeugschein_zb_1;
            _this.files_rueckrufschreiben = response.data.rueckrufschreiben;
          });

    },

    verifyVM() {
      this.nextStep(4);
      if (this.validateForm(4)) {
        if (process.env.VUE_APP_ENV === "prod") {
          axios.get(this.api_vm_url + this.token + '&finish=1&create-vm=j');
        }
      }
    },

    formularSchliessen() {

      this.status_ordner = "Vollmacht eingegangen";
      this.update('vollmacht_eingegangen');

    },

    inWartelisteEintragen() {

      this.update('warteliste');

    },
    //Google Analytics Tracking
    sendGAfromAutocomplete() {
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";
      this.$gtag.event('focus', {
        'event_category': devPrefix + "Abgas Personal Formular",
        'event_label': "google-address (text)"
      });
    },
    sendGaEvent($event) {
      //Google Analytics
      let devPrefix = "";
      if (process.env.VUE_APP_ENV !== "prod") devPrefix = "(TEST) ";

      let label = '';
      if($event.target.getAttribute('data-name')) {
        label = $event.target.getAttribute('data-name')+" ("+$event.target.type+")";
        //console.log('Name = Label: '+label);
        //console.log('Type: '+$event.type);
      } else {
        label = $event.target.id;
        //console.log('ID = Label: '+label);
        //console.log('Type: '+$event.type);
      }
      this.$gtag.event($event.type, {
        'event_category': devPrefix + "Abgas Personal Formular",
        'event_label': label
      });
    }

  },

  computed: {

    isSelbstzahler() {
      const levenshtein = require('js-levenshtein');
      let lowModellInputWords = this.modell.toLowerCase().split(" ");
      let lowMarkeInputWords = this.automarke.toLowerCase().split(" ");
      let lowMarken = [
        "porsche"
      ];
      let lowModelsStrings = [
        'macan',
        'cayenne',
        'panamera',
        'touareg',
        'amarok'
      ];
      let lowModelsRegEx = [
        /^(([aq][5-9])|(s[4-9]))$/ // Audi A/Q 5 - A/Q 9 & Audi S5 - S9
      ];
      let maxLeven = 1;
      let returnVal = false;
      lowModellInputWords.forEach(function(input) {
        lowModelsRegEx.forEach(function(regEx) {
          if (input.match(regEx)) {
            returnVal = true;
            return false; // break
          }
        });
        lowModelsStrings.forEach(function(model) {
          if (input == model) {
            returnVal = true;
            return false; // break
          }
          if (levenshtein(input,model) <= maxLeven) {
            returnVal = true;
            return false; // break
          }
        });
      });
      lowMarkeInputWords.forEach(function(input) {
        lowMarken.forEach(function(marke) {
          if (input == marke) {
            returnVal = true;
            return false; // break
          }
          if (levenshtein(input,marke) <= maxLeven) {
            returnVal = true;
            return false; // break
          }
        });
      });
      return returnVal;
    }

  }
}
</script>
